import React, { useMemo } from "react";
import styled from "styled-components/macro";
import { responsive, nombreEleccion, eleccion } from "../../../resources/constantes.json";
import Grafica from "../../../components/Grafica/Grafica";
import { getOption } from "./InterfazHemiciclo";
import { useLanguage, useTranslate } from "../../../contexts/languageContext";
import useMediaQuery, { useIsDesktop } from "../../../hooks/useMediaQuery";
import LeyendaPartidos from "../../../components/Grafica/Leyenda/LeyendaPartidos";
import LeyendaCamaras from "../../../components/Grafica/Leyenda/LeyendaCamaras";
import {themes} from "../../../styles/themes";
import { Link } from "react-router-dom";

const Hemiciclo = ({data, nomenclator, idEleccion}) => {
  const lang = useLanguage();
  const t = useTranslate();
  const isSmall = useMediaQuery("screen and (max-width: 480px)");
  const isDesktop = useIsDesktop();
  const nombreCitrep = nomenclator.nomAmbitos[eleccion.citrep]?.n
  const option = useMemo(
    () => getOption(data, nomenclator, idEleccion, isSmall, isDesktop, t, lang, nombreCitrep),
    [data, nomenclator, idEleccion, isSmall, isDesktop, t, lang, nombreCitrep]
  );
  return (
    <div
      css={`
        display: flex;
        justify-content: center;
        height: 100%;
        width: 100%;
        flex-direction: column;
        margin: 0 auto;
        // transform: scale(${200 / 320});
        @media screen and (max-width: ${responsive.tablet}px) {
          flex-direction: column;
          align-items: center;
        }
      `}
    >
      <Grafica
        option={option}
        animationDelay={200}
        // events={events}
        css={`
          width: 90%;
          height: ${isSmall ? "200px" : "400px"};
          margin: 0 auto;
        `}
      />
      {
        idEleccion === eleccion.camara &&
        (<LinkContainer>
          <SLink color={themes.color.circPaz} to={"/"+nombreEleccion[eleccion.citrep]+"/0/colombia"}>
            {t('leyendaShowCitrep').replace("%eleccion%", nombreCitrep)}
          </SLink>
        </LinkContainer>)
      }
      <Leyenda data={data} idEleccion={idEleccion} t={t}/>
    </div>
  );
};
export const Leyenda = ({ data, idEleccion, t}) => {
  const convocatoria = 'act';
  const partidos = data.camaras.map(camara => camara.partotabla.filter(p => p[convocatoria].carg !== '0')).flat();
  const sinInfo = data.totales[convocatoria].pmesesc === "0%";
  const totales = data.camaras.reduce((prev, current) => Number(prev.cam) + Number(current.carg), 0);
  return (
    <LeyendaContainer>
      <LeyendaCamaras
        data={data}
        idEleccion={idEleccion}
        title={t('camaras')}
      />
      <LeyendaPartidos
        data={partidos}
        sinInfo={sinInfo}
        totales={totales}
      />
    </LeyendaContainer>
  );
};

const LeyendaContainer = styled.div`
  display:flex;
  flex-direction:column;
  margin-top: 20px;
  & > * {
    margin: 20px;
  }
  @media (max-width: ${responsive.tablet}px) {
    width: 100%;
    & > * {margin: 10px 0;}
  }
  @media (max-width: ${responsive.mobile}px) {
    width: 100%;
    & > * {margin: 10px 0;}
  }
`;

const SLink = styled(Link)`
  font-family: Lato;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 17px;
  width: 250px;
  display: flex;
  align-items: center;
  text-align: center;
  justify-content: center;
  color: #FFFF;
  border: 1px solid #FFF;
  background-color: ${({ color }) => color};
  border-radius: 10px;
  padding: 1rem;
  margin-right: 2rem;
  text-transform: lowercase;
  :hover{
    text-decoration:none;
    color: ${({ color }) => color};
    background-color: #FFF;
    border: 1px solid ${({ color }) => color};
  }
`;

const LinkContainer = styled.div`
  display:flex;
  width:100%;
  justify-content: flex-end;
  @media (max-width: ${responsive.tablet}px) {
    justify-content: center;
  }
  @media (max-width: ${responsive.mobile}px) {
    justify-content: center;
  }
`;

export default Hemiciclo;
